import { useMemo } from "react"
import { StatusFilter } from "@/Overtime/enums/markets"
import useSportsMarketsV2Query from "@/Overtime/queries/useSportsMarketsV2Query"
import useLiveSportsMarketsQuery from "@/Overtime/queries/useLiveSportsMarketsQuery"
import useChainProviderHook from "./useChainProvider"
import { useLive } from "@azuro-org/sdk"

export type FormattedSportMarkets = {
  openSportMarkets: unknown
  isLoading: boolean
  isError: boolean
}

export const useOvertimeFormattedSportsMarkets = (): FormattedSportMarkets => {
  const { isLive } = useLive()
  const { chainId } = useChainProviderHook()

  const openSportMarketsQuery = useSportsMarketsV2Query(
    StatusFilter.OPEN_MARKETS,
    false,
    { networkId: chainId },
    undefined
  )

  const liveSportMarketsQuery = useLiveSportsMarketsQuery({
    networkId: chainId,
  })

  const liveSportMarkets = useMemo(() => {
    if (liveSportMarketsQuery.isSuccess && liveSportMarketsQuery.data) {
      return liveSportMarketsQuery.data.live
    }
    return undefined
  }, [liveSportMarketsQuery.data, liveSportMarketsQuery.isSuccess])

  const openSportMarkets = useMemo(() => {
    if (openSportMarketsQuery.isSuccess && openSportMarketsQuery.data) {
      return openSportMarketsQuery.data[StatusFilter.OPEN_MARKETS]
    }
    return undefined
  }, [openSportMarketsQuery.data, openSportMarketsQuery.isSuccess])

  return {
    openSportMarkets: isLive ? liveSportMarkets || [] : openSportMarkets || [],
    isLoading: isLive
      ? liveSportMarketsQuery.isLoading
      : openSportMarketsQuery.isLoading,
    isError: isLive
      ? liveSportMarketsQuery.isError
      : openSportMarketsQuery.isError,
  }
}

// Legacy hook for backward compatibility
export const useSportsMarkets = (
  networkIdOrParams: number | { chainId: number; isLive: boolean }
) => {
  // Handle both parameter formats

  return useOvertimeFormattedSportsMarkets()
}
